<div class="app-container">
  <div fxLayout="row" fxFlex>
    <div
      class="sidemenu-container"
      [ngClass]="AppSettings.IsRunningInSingularity ? 'm-top-45' : ''"
      fxLayout="column"
    >
      <mat-nav-list class="main-menu-list">
        <!-- <a
          mat-list-item
          [routerLink]="['dashboard']"
          [ngClass]="{
            active: masterService.ActiveParentRoute === 'Dashboard'
          }"
          matTooltip="{{ 'LBL.DASHBOARD' | translate }}"
          matTooltipPosition="after"
          (click)="
            sidenavSubmenu.close();
            masterService.ActiveParentRoute = 'Dashboard';
            selectedParentRoute = 'Dashboard'
          "
        >
          <mat-icon mat-list-icon>dashboard</mat-icon>
        </a> -->
        <!-- <div class="sidebar-menu-entry"></div> -->
        <a
          mat-list-item
          class="sidebar-menu-entry"
          *ngIf="CheckAuth_EntityCode(_EntityCodes.Asset)"
          [ngClass]="{ active: masterService.ActiveParentRoute === 'Asset' }"
          matTooltip="{{ 'NAV.NAV_ASSET' | translate }}"
          matTooltipPosition="after"
          (click)="sidenavSubmenu.open(); selectedParentRoute = 'Asset'"
        >
          <!-- <mat-icon mat-list-icon>build</mat-icon> -->
          <div class="text-center sidebar-icon-container">
            <!-- <span class="sidebar-menu-icon kmt-icon-asset"></span> -->
            <img
              class="icon"
              src="assets/images/Vector.svg"
              class="side1-icon w-h-35"
            />
          </div>
        </a>

        <a
          mat-list-item
          class="sidebar-menu-entry"
          [ngClass]="{
            active: masterService.ActiveParentRoute === 'Workorder'
          }"
          matTooltip="{{ 'NAV.NAV_WORK_ORDER_CONSOLE' | translate }}"
          matTooltipPosition="after"
          (click)="sidenavSubmenu.open(); selectedParentRoute = 'Workorder'"
        >
          <!-- <mat-icon mat-list-icon>assignment_ind</mat-icon> -->
          <div class="text-center sidebar-icon-container">
            <img
              class="icon"
              src="assets/images/edit-note.svg"
              class="side1-icon w-h-35"
            />
          </div>
        </a>

        <a
          mat-list-item
          class="sidebar-menu-entry"
          *ngIf="CheckAuth_EntityCode(_EntityCodes.PM)"
          [ngClass]="{ active: masterService.ActiveParentRoute === 'PM' }"
          matTooltip="{{ 'NAV.NAV_PREVENTIVE_MAINTENANCE' | translate }}"
          matTooltipPosition="after"
          (click)="sidenavSubmenu.open(); selectedParentRoute = 'PM'"
        >
          <!-- <mat-icon mat-list-icon>folder</mat-icon> -->
          <div class="text-center sidebar-icon-container">
            <img class="icon" src="assets/images/pm.svg" class="side1-icon" />
          </div>
        </a>

        <a
          class="sidebar-menu-entry"
          mat-list-item
          *ngIf="CheckAuth_Action(_AuthActionCodes.Report_Run)"
          [ngClass]="{ active: masterService.ActiveParentRoute === 'Reports' }"
          matTooltip="{{ 'NAV.NAV_STD_REPORTS' | translate }}"
          matTooltipPosition="after"
          [routerLink]="['reports']"
          (click)="
            sidenavSubmenu.close();
            masterService.ActiveParentRoute = 'Reports';
            selectedParentRoute = 'Reports'
          "
        >
          <div class="sidebar-icon-container">
            <!-- <mat-icon mat-list-icon>table_chart</mat-icon> -->
            <img
              class="icon"
              src="assets/images/reports.svg"
              class="side1-icon"
            />
          </div>
        </a>

        <a
          class="sidebar-menu-entry"
          mat-list-item
          *ngIf="CheckAuth_Action(_AuthActionCodes.Report_Run) && analyticsURL"
          [ngClass]="{
            active: masterService.ActiveParentRoute === 'Analytics'
          }"
          matTooltip="{{ 'NAV.NAV_STD_ANALYTICS' | translate }}"
          matTooltipPosition="after"
          [routerLink]="['analytics']"
          (click)="
            sidenavSubmenu.close();
            masterService.ActiveParentRoute = 'Analytics';
            selectedParentRoute = 'Analytics'
          "
        >
          <div class="sidebar-icon-container">
            <img
              class="icon"
              src="assets/images/analytics.svg"
              class="side1-icon w-h-35"
            />
          </div>
        </a>
      </mat-nav-list>
      <div class="vertical-spacer" fxFlex></div>
      <mat-nav-list class="main-menu-list">
        <a
          mat-list-item
          class="sidebar-menu-entry"
          [ngClass]="{
            active: masterService.ActiveParentRoute == 'Settings'
          }"
          matTooltip="{{ 'NAV.NAV_SETTINGS' | translate }}"
          matTooltipPosition="after"
          (click)="sidenavSubmenu.open(); selectedParentRoute = 'Settings'"
        >
          <img
            class="icon"
            src="assets/images/settings.svg"
            class="side1-icon"
          />
        </a>
      </mat-nav-list>
    </div>
    <mat-sidenav-container fxFlex>
      <mat-sidenav
        #sidenavSubmenu
        class="submenu-container main-sidenav"
        mode="over"
        (keydown.escape)="sidenavSubmenu.close()"
      >
        <mat-list *ngIf="selectedParentRoute === 'PM'">
          <h3 matSubheader>{{ 'LBL.PM' | translate }}</h3>
          <mat-divider></mat-divider>
          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.PM_Add)"
            [routerLink]="['pm']"
            [ngClass]="{
              active:
                masterService.ActiveUrl === '/app/pm' ||
                masterService.ActiveUrl === ''
            }"
            (click)="
              sidenavSubmenu.close(); masterService.ActiveParentRoute = 'PM'
            "
          >
            {{ 'NAV.NAV_NEW_PM' | translate }}
          </mat-list-item>

          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.PM_Console_View)"
            [routerLink]="['pm/console']"
            [ngClass]="{
              active: masterService.ActiveUrl === '/app/pm/console'
            }"
            (click)="
              sidenavSubmenu.close(); masterService.ActiveParentRoute = 'PM'
            "
            >{{ 'NAV.NAV_PM_CONSOLE' | translate }}
          </mat-list-item>
          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.PM_Console_View)"
            [routerLink]="['pm/calendar']"
            [ngClass]="{
              active: masterService.ActiveUrl === '/app/pm/calendar'
            }"
            (click)="
              sidenavSubmenu.close(); masterService.ActiveParentRoute = 'PM'
            "
            >{{ 'NAV.NAV_PM_CALENDAR' | translate }}
          </mat-list-item>

          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.PM_Console_View)"
            [routerLink]="['pm/list']"
            [ngClass]="{
              active: masterService.ActiveUrl === '/app/pm/list'
            }"
            (click)="
              sidenavSubmenu.close(); masterService.ActiveParentRoute = 'PM'
            "
            >{{ 'NAV.NAV_PM_COMPLIANCE_VIEW' | translate }}
          </mat-list-item>
        </mat-list>
        <mat-list *ngIf="selectedParentRoute === 'Workorder'">
          <h3 matSubheader>{{ 'LBL.WORK_ORDER' | translate }}</h3>
          <mat-divider></mat-divider>
          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.WorkOrder_Add)"
            [routerLink]="['workorder']"
            [ngClass]="{
              active: masterService.ActiveUrl === '/app/workorder'
            }"
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Workorder'
            "
          >
            {{ 'NAV.NAV_NEW_WORK_ORDER' | translate }}
          </mat-list-item>
          <mat-list-item
            [routerLink]="['workorder/console']"
            [ngClass]="{
              active: masterService.ActiveUrl === '/app/workorder/console'
            }"
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Workorder'
            "
            >{{ 'NAV.NAV_WO_CONSOLE' | translate }}
          </mat-list-item>

          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.WorkOrder_Console_View)"
            [routerLink]="['workorder/locationOverview']"
            [ngClass]="{
              active:
                masterService.ActiveUrl === '/app/workorder/locationOverview'
            }"
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Workorder'
            "
            >{{ 'NAV.NAV_WO_LOCATION_OVERVIEW' | translate }}
          </mat-list-item>
        </mat-list>
        <mat-list *ngIf="selectedParentRoute === 'Asset'">
          <h3 matSubheader>{{ 'LBL.ASSET' | translate }}</h3>
          <mat-divider></mat-divider>
          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.Asset_Add)"
            [routerLink]="['asset']"
            [ngClass]="{
              active: masterService.ActiveUrl === '/app/asset'
            }"
            (click)="
              sidenavSubmenu.close(); masterService.ActiveParentRoute = 'Asset'
            "
          >
            {{ 'NAV.NAV_NEW_ASSET' | translate }}
          </mat-list-item>
          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.Asset_Console_View)"
            [routerLink]="['asset/console']"
            [ngClass]="{
              active: masterService.ActiveUrl === '/app/asset/console'
            }"
            (click)="
              sidenavSubmenu.close(); masterService.ActiveParentRoute = 'Asset'
            "
            >{{ 'NAV.NAV_ASSET_CONSOLE' | translate }}
          </mat-list-item>
          <!-- <mat-divider></mat-divider>
          <mat-list-item
            [routerLink]="['asset/assetMetricConsole']"
            [ngClass]="{
              active:
                masterService.ActiveUrl === '/app/asset/assetMetricConsole'
            }"
            (click)="
              sidenavSubmenu.close(); masterService.ActiveParentRoute = 'Asset'
            "
            >Asset Metrics
          </mat-list-item> -->
        </mat-list>
        <mat-list *ngIf="selectedParentRoute === 'Settings'">
          <h3 matSubheader>{{ 'LBL.SETTINGS' | translate }}</h3>
          <mat-divider></mat-divider>
          <!-- Account -->
          <!-- <mat-list-item
            [routerLink]="['settings/user']"
            [ngClass]="{
              active: masterService.ActiveUrl === '/app/settings/user'
            }"
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Settings'
            "
          >
            {{ 'LBL.ACCOUNT' | translate }}
          </mat-list-item>
          <mat-divider></mat-divider> -->
          <!-- User Group -->
          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.UserGroup_Console_View)"
            [routerLink]="['settings/manageGroup']"
            [ngClass]="{
              active:
                masterService.ActiveUrl === '/app/settings/manageGroup' ||
                masterService.ActiveUrl === '/app/settings/group'
            }"
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Settings'
            "
            >{{ 'LBL.USER_GROUP' | translate }}
          </mat-list-item>
          <!-- Metrics -->
          <!-- <mat-list-item
            [routerLink]="['settings/manageMetric']"
            [ngClass]="{
              active:
                masterService.ActiveUrl === '/app/settings/manageMetric' ||
                masterService.ActiveUrl === '/app/settings/metric'
            }"
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Settings'
            "
          >
            {{ 'LBL.METRICS' | translate }}
          </mat-list-item>
          <mat-divider></mat-divider> -->
          <!-- Asset Category -->
          <mat-list-item
            *ngIf="
              CheckAuth_Action(_AuthActionCodes.Asset_Category_Console_View)
            "
            [routerLink]="['settings/manageAssetCategory']"
            [ngClass]="{
              active:
                masterService.ActiveUrl ===
                  '/app/settings/manageAssetCategory' ||
                masterService.ActiveUrl === '/app/settings/assetCategory'
            }"
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Settings'
            "
          >
            {{ 'LBL.ASSET_CATEGORY' | translate }}
          </mat-list-item>
          <!-- <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.Task_Console_View)"
            [routerLink]="['tasklist/taskgrouplist']"
            [ngClass]="{
              active:
                masterService.ActiveUrl === '/app/tasklist/taskgrouplist' ||
                masterService.ActiveUrl === '/app/tasklist/task' ||
                masterService.ActiveUrl === '/app/tasklist/taskgroup'
            }"
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Tasklist'
            "
          >
            {{ 'NAV.NAV_TASKLIST_CONSOLE' | translate }}
          </mat-list-item>
          <mat-divider></mat-divider> -->
          <mat-list-item
            *ngIf="CheckAuth_Action(_AuthActionCodes.Checklist_Console_View)"
            [routerLink]="['checklist/console']"
            [ngClass]="{
              active:
                masterService.ActiveUrl === '/app/checklist/console' ||
                masterService.ActiveUrl === '/app/checklist/checklist' ||
                masterService.ActiveUrl === '/app/checklist/checklist-item'
            }"
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Checklist'
            "
          >
            {{ 'NAV.NAV_CHECKLIST_CONSOLE' | translate }}
          </mat-list-item>
          <mat-list-item
            [routerLink]="['settings/manageTranslation']"
            *ngIf="
              authorizationService.IsPropertyAdmin() ||
              CheckAuth_Action(_AuthActionCodes.MNT_Config_View)
            "
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Settings'
            "
            [ngClass]="{
              active:
                masterService.ActiveUrl === '/app/settings/manageTranslation'
            }"
          >
            {{ 'NAV.NAV_MANAGE_TRANSLATION' | translate }}
          </mat-list-item>
          <mat-list-item
            [routerLink]="['settings/manageBulkImport']"
            *ngIf="
              authorizationService.IsPropertyAdmin() ||
              CheckAuth_Action(_AuthActionCodes.MNT_Config_View)
            "
            (click)="
              sidenavSubmenu.close();
              masterService.ActiveParentRoute = 'Settings'
            "
            [ngClass]="{
              active:
                masterService.ActiveUrl === '/app/settings/manageBulkImport'
            }"
          >
            {{ 'NAV.NAV_MANAGE_BULK_IMPORT' | translate }}
          </mat-list-item>
        </mat-list>
      </mat-sidenav>
      <mat-sidenav-content>
        <div class="page-container" fxFlex>
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
      <mat-sidenav
        class="notification-panel"
        #sidenavMessages
        [(opened)]="navHeader.notificationPanelOpened"
        position="end"
        mode="over"
      >
        <kmt-message-sidebar
          class="flex-container"
          fxLayout="column"
          fxLayoutGap="8px"
        ></kmt-message-sidebar>
      </mat-sidenav>
    </mat-sidenav-container>
  </div>
</div>
